module.exports = __webpack_public_path__ + "img/top.3271e147.png";